var parkingLocationPagesDE = {
  'de/schoenefeld-flughafen-parken': 'Berlin-Schönefeld',
  'de/tegel-flughafen-parken': 'Berlin-Tegel',
  'de/bremen-flughafen-parken': 'Bremen',
  'de/dortmund-flughafen-parken': 'Dortmund',
  'de/duesseldorf-flughafen-parken': 'Düsseldorf International',
  'de/dresden-flughafen-parken': 'Dresden',
  'de/erfurt-flughafen-parken': 'Erfurt',
  'de/parken-flughafen-frankfurt': 'Frankfurt am Main',
  'de/frankfurt-hahn-flughafen-parken': 'Frankfurt-Hahn',
  'de/hamburg-flughafen-parken': 'Hamburg',
  'de/hannover-flughafen-parken': 'Hannover',
  'de/karlsruhe-baden-baden-flughafen-parken': 'Karlsruhe/Baden-Baden',
  'de/koeln-flughafen-parken': 'Köln-Bonn',
  'de/leipzig-flughafen-parken': 'Leipzig/Halle',
  'de/memmingen-flughafen-parken': 'Memmingen',
  'de/muenchen-flughafen-parken': 'München',
  'de/nuernberg-flughafen-parken': 'Nürnberg',
  'de/stuttgart-flughafen-parken': 'Stuttgart',
  'de/weeze-flughafen-parken': 'Weeze (Niederrhein)',
  'de/nurparken2': 'Flughafen Parken Europa'
}

module.exports = parkingLocationPagesDE



// WEBPACK FOOTER //
// ./shared/config/parkingLocationPagesDE.js